<zimmerer-route-ion-wrapper class="ion-page">
  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col" fxLayout="column" fxLayoutGap="30px">
      <image-slider page="vorteile" fxHide.lt-lg no-image-margin="30px"></image-slider>

      <div class="part" fxLayout="column" fxLayoutGap="15px">
        <!-- mobile only -->
        <div fxLayout="row" fxLayoutAlign="center center" fxHide.gt-md>
          <div class="logo unselectable"></div>
        </div>

        <h1 style="text-align: center">Der Treffpunkt für Zimmerer im Internet.</h1>

        <p style="text-align: center">
          Der Zimmerer-Treffpunkt ist die Plattform, auf der Zimmerer sich Online treffen, austauschen und informieren.
          Es geht um Holz, und um diejenigen, die damit arbeiten: Zimmerinnen und Zimmerer, Azubis, Gesellen und
          Meister.
        </p>

        <div fxLayout="row" fxLayoutAlign="center center">
          <div class="checkmarks" fxLayout="column" fxLayoutGap="5px">
            <div><i class="fas fa-check-square"></i> mit anderen vernetzen und austauschen</div>
            <div><i class="fas fa-check-square"></i> Zimmereibedarf kaufen und verkaufen</div>
            <div><i class="fas fa-check-square"></i> neue Jobs und neues Personal finden</div>
            <div><i class="fas fa-check-square"></i> weiterbilden und Wissen teilen</div>
            <div><i class="fas fa-check-square"></i> den Holzbau gemeinsam voranbringen</div>
          </div>
        </div>
      </div>

      <div
        class="part"
        fxLayout="column"
        fxLayoutAlign="start center"
        fxLayoutGap="15px"
        *ngIf="!userService.isLoggedIn"
      >
        <button class="orange-button" (click)="openLoginRegistration('registration')">
          Jetzt kostenlos Mitglied werden
        </button>

        <div style="text-align: center">Du bist bereits Mitglied?</div>

        <button class="blue-button" (click)="openLoginRegistration('login')">Dann hier anmelden</button>
      </div>

      <div class="part" fxLayout="column" fxLayoutGap="15px">
        <h2>Werde Teil unserer wachsenden Online-Community - der Zimmerei Treffpunkt</h2>

        <div fxHide.lt-lg>
          Wir haben den schönsten Beruf der Welt, und wir halten zusammen. Gemeinsam verhelfen wir dem Werkstoff Holz
          zum Durchbruch, und leisten damit einen Beitrag für eine bessere Welt. Teile Dein Wissen und profitiere von
          den Erfahrungen anderer. Hier kannst Du Gebrauchtes verkaufen, Mitarbeiter finden, Dich weiterbilden und Dein
          Handwerk mitgestalten. Mach mit, als Zimmerer oder Zimmerin gehörst Du dazu!
        </div>

        <app-benefits></app-benefits>

        <p fxHide.gt-md>
          Wir haben den schönsten Beruf der Welt, und wir halten zusammen. Gemeinsam verhelfen wir dem Werkstoff Holz
          zum Durchbruch, und leisten damit einen Beitrag für eine bessere Welt. Teile Dein Wissen und profitiere von
          den Erfahrungen anderer. Hier kannst Du Gebrauchtes verkaufen, Mitarbeiter finden, Dich weiterbilden und Dein
          Handwerk mitgestalten. Mach mit, als Zimmerer oder Zimmerin gehörst Du dazu!
        </p>
      </div>

      <div class="part" fxLayout="column" fxLayoutGap="15px">
        <h2>Deine Funktionen im Überblick</h2>

        <!-- usecases -->
        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="usecases">
          <div
            *ngFor="let item of b3"
            fxLayout="row"
            fxLayoutGap="20px"
            (click)="usageClick(item)"
            class="usecase unselectable"
            fxFlex="100"
            fxFlex.gt-md="50"
          >
            <div fxFlex="noshrink">
              <div class="usecaseicon" [innerHTML]="item.icon"></div>
            </div>
            <div class="usecasetext" fxFlex="grow" [innerHTML]="item.text"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="banner-container">
      <newsfeed-top-banner></newsfeed-top-banner>
    </div>
  </div>

  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col noSlider" fxLayout="column" fxLayoutGap="30px">
      <!-- statements -->
      <div class="part" fxLayout="column" fxLayoutGap="15px">
        <h2>Sieh was andere über uns sagen</h2>

        <div fxLayout="column" fxLayoutGap="20px" fxHide.lt-lg>
          <div *ngFor="let statement of statements" class="statement" fxLayout="row" fxLayoutGap="20px">
            <div>
              <div class="statementImage" [style.background-image]="'url(' + statement.img + ')'"></div>
            </div>
            <div style="font-style: italic">
              <div>{{ statement.text }}</div>
              <div>- {{ statement.name }}</div>
            </div>
          </div>
        </div>

        <app-slider fxHide.gt-md [sliderItems]="statements" [smallimage]="true" [rawImage]="true"></app-slider>
      </div>

      <!-- FAQ -->
      <div class="part" fxLayout="column" fxLayoutGap="15px">
        <h2>Noch Fragen? Hier findest Du Deine Antworten.</h2>
        <div fxLayout="column" fxLayoutGap="20px">
          <mat-expansion-panel *ngFor="let f of faq">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ f.question }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p>{{ f.answer }}</p>
          </mat-expansion-panel>
        </div>

        <!-- register button -->
        <div style="text-align: center">
          <button
            *ngIf="!userService.isLoggedIn"
            class="orange-button"
            (click)="openLoginRegistration('registration')"
            style="margin-top: 20px"
          >
            Jetzt registrieren
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</zimmerer-route-ion-wrapper>
